import axios from "./axiosConfig";

const techniciansService = {
  getAll() {
    return axios.get("/technicians");
  },

  create(data) {
    return axios.post("/technicians", data);
  },

  update(id, data) {
    return axios.put(`/technicians/${id}`, data);
  },

  delete(id) {
    return axios.delete(`/technicians/${id}`);
  },

  getRanking(year, month) {
    return axios.get("/technicians/ranking", {
      params: { year, month },
    });
  }
};

export default techniciansService;